import styled from "styled-components"

import Form from "@irati/ui/src/Form"

export const StyledForm = styled(Form)`
  width: 100%;
`

export const ResponsiveImg = styled.img`
  width: 250px;
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
  width: 120px;
  `}
`
